import axios from "axios";

export function setupAuthHeaderForServiceCalls(token) {
    if (token) {
      return (axios.defaults.headers.common["Authorization"] = token);
    }
    delete axios.defaults.headers.common["Authorization"];
  }
  
 export function setupAuthExceptionHandler(logoutUser, navigate) {
    const UNAUTHORIZED = 401;
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === UNAUTHORIZED) {
          logoutUser();
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );
  }